import { type FilterValues } from "components/filters/FilterContext";
import { mapKeywordFilterToInstruction, mapResponseToKeywordFilter } from "components/filters/mappingUtils";
import { routes } from "utilities/routing/generatedRoutes";

export const mapFilterValuesToInstruction = (
  mainArea: server.dto.MainAreas,
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedWordTemplateForListViewInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    page,
    perPage,
    cache: filterSet,
    mainArea
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListWordTemplateForListViewFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
});


type WordTemplateMapping = {
  detail: (id: number) => string;
  new: () => string;
  filterSet: server.dto.FilterSets;
}

export const getMainAreaMapping = (mainArea: server.dto.MainAreas): WordTemplateMapping => {
  switch (mainArea) {
    case "show": return {
      detail: (id: number) => routes.wordTemplateForListView_Detail(id).absolute,
      new: () => routes.wordTemplateForListView_New(mainArea).absolute,
      filterSet: "wordTemplateForListView_Show_List",
    };
    case "company": return {
      detail: (id: number) => routes.wordTemplateForListView_Detail(id).absolute,
      new: () => routes.wordTemplateForListView_New(mainArea).absolute,
      filterSet: "wordTemplateForListView_Company_List",
    };
    case "contact": return {
      detail: (id: number) => routes.wordTemplateForListView_Detail(id).absolute,
      new: () => routes.wordTemplateForListView_New(mainArea).absolute,
      filterSet: "wordTemplateForListView_Contact_List",
    };
    case "invoice": return {
      detail: (id: number) => routes.wordTemplateForListView_Detail(id).absolute,
      new: () => routes.wordTemplateForListView_New(mainArea).absolute,
      filterSet: "wordTemplateForListView_Invoice_List",
    };
    case "contract": return {
      detail: (id: number) => routes.wordTemplateForListView_Detail(id).absolute,
      new: () => routes.wordTemplateForListView_New(mainArea).absolute,
      filterSet: "wordTemplateForListView_Contract_List",
    };
    case "purchaseAgreement": return {
      detail: (id: number) => routes.wordTemplateForListView_Detail(id).absolute,
      new: () => routes.wordTemplateForListView_New(mainArea).absolute,
      filterSet: "wordTemplateForListView_PurchaseAgreement_List",
    };
    case "quote": return {
      detail: (id: number) => routes.wordTemplateForListView_Detail(id).absolute,
      new: () => routes.wordTemplateForListView_New(mainArea).absolute,
      filterSet: "wordTemplateForListView_Quote_List",
    };
  }
}